/* Brief 83 Part B: approximate local-currency hint for yen prices, site-wide.
   Any element with data-jpy="8000" gets <span class="phj-local">≈ £39</span> appended when the visitor's active
   currency is not JPY (Shopify.currency.active / .rate, the storefront's own conversion rate). Elements with
   data-local-note, and #mbg-price-note, get one explanatory sentence. Nothing happens in JPY.
   Idempotent: a cell that already holds .phj-local or .mbg-local (the buying guide's own inline script) is skipped,
   and a note is only appended to once. Re-runs on shopify:section:load for the theme editor. No jQuery. */
(function () {
  var NOTE_MARK = 'approximate conversions to';
  function run(root) {
    try {
      var c = window.Shopify && window.Shopify.currency;
      if (!c || !c.active || c.active === 'JPY') return;
      var rate = parseFloat(c.rate);
      if (!rate || rate <= 0) return;
      var scope = root && root.querySelectorAll ? root : document;
      var cells = scope.querySelectorAll('[data-jpy]');
      var done = 0;
      for (var i = 0; i < cells.length; i++) {
        var el = cells[i];
        if (el.querySelector('.phj-local, .mbg-local')) { done++; continue; }
        var v = parseFloat(el.getAttribute('data-jpy')) * rate;
        if (!isFinite(v)) continue;
        var digits = v < 20 ? 2 : 0;
        var fmt;
        try {
          fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: c.active, minimumFractionDigits: digits, maximumFractionDigits: digits });
        } catch (e) { continue; }
        var sp = document.createElement('span');
        sp.className = 'phj-local';
        sp.textContent = '≈ ' + fmt.format(v);
        el.appendChild(sp);
        done++;
      }
      if (!done) return;
      var notes = scope.querySelectorAll('#mbg-price-note, [data-local-note]');
      for (var n = 0; n < notes.length; n++) {
        var note = notes[n];
        if (note.getAttribute('data-phj-local-noted') || (note.textContent || '').indexOf(NOTE_MARK) !== -1) continue;
        note.appendChild(document.createTextNode(' Figures marked ≈ are approximate conversions to ' + c.active + ' at today’s rate; the product page shows the exact price you pay.'));
        note.setAttribute('data-phj-local-noted', '1');
      }
    } catch (e) { /* a hint only: never break the page */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  window.PHJLocalPrice = { run: run };
})();
